import { create } from 'lodash';
import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const FETCH_TRANSACTIONS: any = createRequestTypes('transactions/FETCH_TRANSACTIONS');
export const FETCH_TRANSACTIONS_RESET: any = createRequestTypes('transactions/FETCH_TRANSACTIONS_RESET');
export const SEARCH_TRANSACTIONS: any = createRequestTypes('transactions/SEARCH_TRANSACTIONS');

export const PATCH_TRANSACTION: any = createRequestTypes('transactions/PATCH_TRANSACTION');
export const PATCH_TRANSACTION_RESET: any = 'transactions/PATCH_TRANSACTION_RESET';

export const TOGGLE_TRANSACTION: any = 'transactions/TOGGLE_TRANSACTION';
export const TOGGLE_TRANSACTIONS: any = 'transactions/TOGGLE_TRANSACTIONS';
export const RESET_SELECTED_TRANSACTIONS: any = 'transactions/RESET_SELECTED_TRANSACTIONS';

export const POST_BATCH: any = createRequestTypes('transactions/POST_BATCH');

export const SUBMIT_OTP: any = createRequestTypes('transactions/SUBMIT_OTP');
export const RESEND_OTP: any = createRequestTypes('transactions/RESEND_OTP');

export const fetchTransactions = {
  request: (params: any) => createAction(FETCH_TRANSACTIONS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(FETCH_TRANSACTIONS[SUCCESS], { response, params }),
  failure: (response: any) => createAction(FETCH_TRANSACTIONS[FAILURE], { response }),
  resetTransactions: (payload: any) => createAction(FETCH_TRANSACTIONS_RESET, { payload }),
};

export const searchTransactions = {
  request: (params: any) => createAction(SEARCH_TRANSACTIONS[REQUEST], { params }),
  success: (response: any, params: any) => createAction(SEARCH_TRANSACTIONS[SUCCESS], { response, params }),
  failure: (response: any) => createAction(SEARCH_TRANSACTIONS[FAILURE], { response }),
};

export const patchTransaction = {
  request: (params: any) => createAction(PATCH_TRANSACTION[REQUEST], { params }),
  success: (response: any, params: any) => createAction(PATCH_TRANSACTION[SUCCESS], { response, params }),
  failure: (response: any) => createAction(PATCH_TRANSACTION[FAILURE], { response }),
  reset: () => createAction(PATCH_TRANSACTION_RESET),
};

export const postBatch = {
  request: (params: any) => createAction(POST_BATCH[REQUEST], { params }),
  success: (response: any, params: any) => createAction(POST_BATCH[SUCCESS], { response, params }),
  failure: (response: any) => createAction(POST_BATCH[FAILURE], { response }),
};

export const toggleTransaction = {
  toggle: (params: any) => createAction(TOGGLE_TRANSACTION, { params }),
  reset: () => createAction(RESET_SELECTED_TRANSACTIONS),
};
export const toggleTransactions = {
  toggle: (params: any) => createAction(TOGGLE_TRANSACTIONS, { params }),
  reset: () => createAction(RESET_SELECTED_TRANSACTIONS),
};

export const submit_otp = {
  request: (params: any) => createAction(SUBMIT_OTP[REQUEST], { params }),
  success: (response: any, params: any) => createAction(SUBMIT_OTP[SUCCESS], { response, params }),
  failure: (response: any) => createAction(SUBMIT_OTP[FAILURE], { response }),
};

export const resend_otp = {
  request: (params: any) => createAction(RESEND_OTP[REQUEST], { params }),
  success: (response: any, params: any) => createAction(RESEND_OTP[SUCCESS], { response, params }),
  failure: (response: any) => createAction(RESEND_OTP[FAILURE], { response }),
};
